<template>
  <div class="unusual-page">
    <section class="content-box">
      <img src="../assets/images/bg_wuquan.png" alt="">
      <div class="detail">
        <h3>403！</h3>
        <p>抱歉，你无权访问该页面</p>
        <a-button type="primary" @click="backToLogin">返回登录页</a-button>
      </div>
    </section>
  </div>
</template>

<script>
import empty from '../js/empty';
export default {
  name: 'noAuth',
  methods: {
    backToLogin () {
      empty.$emit('setCacheData');
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/noAuth.vue